


















import Vue from 'vue'
export default Vue.extend({
  name: 'NavViewLink',
  props: {
    value: Object,
  },
  data() {
    return { model: this.value }
  },
  methods: {
    apply() {
      this.$emit('apply', this.model)
    },
  },
})
